import { render, staticRenderFns } from "./PoliticallyExposedPersonInformation.vue?vue&type=template&id=6cf527ec"
import script from "./PoliticallyExposedPersonInformation.vue?vue&type=script&lang=js"
export * from "./PoliticallyExposedPersonInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports